import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { DuplicateJobRequest, HttpResponse, Job } from "@/types";

export function useDuplicateJob() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      jobId,
      linkToSource,
    }: {
      jobId: string;
      linkToSource?: boolean;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${jobId}/duplicate`;
      const res = await guacHttpClient.post<
        Job,
        HttpResponse<Job>,
        DuplicateJobRequest
      >(path, { linkToSource });

      return res.data;
    },
  });

  return mutation;
}
